import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { QuaiManager_DropDownCaret } from '@app/styles';
import { SeverityLabelMap, SeverityValues } from '@app/dp-shared';
export const Props_SeverityDropDown = {
    adapter: () => SimpleListAdapter([...SeverityValues], severity => _jsx(_Fragment, { children: SeverityLabelMap[severity.item] })),
    placeholder: 'Pick Severity',
    caret: QuaiManager_DropDownCaret,
};
export const DropDown_Severity = TS_DropDown.prepare(Props_SeverityDropDown);
//# sourceMappingURL=ui-components.js.map